import { haveSameElements } from "app/pages/sales-intelligence/utils/arrays";

import type { TechnologiesFilterDto } from "../types/filter-values";

export const hasSameTechnologyObject = (
    item: TechnologiesFilterDto,
    comparedItem: TechnologiesFilterDto | null,
): boolean => {
    if (comparedItem === null) {
        return false;
    }

    return (
        item.inclusion === comparedItem.inclusion &&
        haveSameElements(item.categories, comparedItem.categories) &&
        haveSameElements(item.parentCategories, comparedItem.parentCategories) &&
        haveSameElements(item.technologies, comparedItem.technologies)
    );
};
